import React from 'react'
import {Menu as OMenu, MenuProps as OMenuProps} from '@material-ui/core'
export type MenuProps = Omit<OMenuProps, 'open'> & {open?: boolean}
export const Menu: React.FC<MenuProps> = (props: MenuProps) => {
	return <OMenu open={true} anchorReference='anchorPosition' {...props} />
}
